import {
  minLength,
  maxLength,
  allowedLangs,
  freqProfiles,
  getAllowedDiff,
  badWords,
  moderationErrors,
} from "./config";

export interface ModerationResult {
  success: boolean;
  error?: string;
  lang?: string;
}

export const getTextModerationResult = (question: string): ModerationResult => {
  // console.log("Moderation started");
  const text = question.trim();

  // Базовые проверки (длина, пробелы и т.д.)
  if (text.length < minLength)
    return { success: false, error: moderationErrors.too_short };
  if (text.length > maxLength)
    return { success: false, error: moderationErrors.too_long };

  const spaceCount = (text.match(/ /g) || []).length;
  const words = text.split(/\s+/).filter(Boolean);
  const spaceRatio = spaceCount / text.length;

  if (words.length < 3)
    return { success: false, error: moderationErrors.too_few_words };
  if (spaceCount < 2 || spaceRatio < 0.02)
    return { success: false, error: moderationErrors.too_few_spaces };

  const lower = text.toLowerCase();
  const cyrillicCount = (lower.match(/[а-яё]/gi) || []).length;
  const latinCount = (lower.match(/[a-z]/gi) || []).length;

  let lang: string | null = null;
  if (cyrillicCount > latinCount && cyrillicCount > 0) lang = "ru";
  else if (latinCount > cyrillicCount && latinCount > 0) lang = "en";
  if (!lang)
    return { success: false, error: moderationErrors.unsupported_language };

  // --- Новый блок эвристик ---
  const letters = lower.replace(/[^a-zа-яё]/gi, "").split("");
  const total = letters.length;
  const unique = new Set(letters).size;
  const diversity = unique / total;

  // Средняя и разброс длины слов
  const wordLengths = words.map((w) => w.replace(/[^a-zа-яё]/gi, "").length);
  const avgWordLen =
    wordLengths.reduce((a, b) => a + b, 0) / wordLengths.length;
  const stdWordLen = Math.sqrt(
    wordLengths.reduce((sum, len) => sum + Math.pow(len - avgWordLen, 2), 0) /
      wordLengths.length
  );

  const rareLetters = (lower.match(/[щъьйфюя]/gi) || []).length / total;

  // Проверка на "цикличность" или подозрительную структуру
  /* if (
    diversity < 0.22 ||
    avgWordLen < 3.5 ||
    stdWordLen < 0.8 ||
    rareLetters > 0.15
  ) {
    return {
      success: false,
      error: moderationErrors.unrealistic_frequency,
      lang,
    };
  } */

  // --- Частотный анализ (остался прежний) ---
  if (total >= 100) {
    const counts: Record<string, number> = {};
    letters.forEach((ch) => (counts[ch] = (counts[ch] || 0) + 1));
    const expected = freqProfiles[lang];
    let severeAnomalies = 0;

    for (const [ch, expectedFreq] of Object.entries(expected)) {
      const realFreq = (counts[ch] || 0) / total;

      // Только для частых символов и с более высоким порогом
      if (expectedFreq > 0.01 && realFreq > expectedFreq * 2.5) {
        severeAnomalies++;
      }
    }

    // Блокируем только при множественных аномалиях
    if (severeAnomalies >= 2) {
      return {
        success: false,
        error: moderationErrors.unrealistic_frequency,
        lang,
      };
    }
  }

  const badList = badWords[lang];
  for (const w of badList)
    if (lower.includes(w))
      return {
        success: false,
        error: moderationErrors.offensive_language,
        lang,
      };

  return { success: true, lang };
};
